import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import NewUserSponsorForm from "components/Admin/UserSponsor/NewUserSponsorForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { ADMIN_CREATE_USER_SPONSOR_SAGA } = constants;

const { adminCreateUserSponsorSaga, cleanErrors } = actions;

class NewUserSponsor extends Component {
  static propTypes = {
    createUserSponsor: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        company_name: "",
        email_confirmation: "",
        validFrontend: false,
        user_type: "sponsor",
        registration: "",
        imc: "",
        sponsor_type: "",
      },
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ user: userData });
  };

  // onRepresentativeChange = (event) => {
  //   const userData = {
  //     ...this.state.user,
  //     ...{
  //       is_representative: event.target.value == 'true',
  //     }
  //   }
  //   this.setState({ user: userData })
  // }

  onSubmit = () => {
    this.props.createUserSponsor(this.state.user);
  };

  render() {
    const { errors, errorsFrontend } = this.props;
    return (
      <main className="site--width clearfix-c">
        <NewUserSponsorForm
          onFieldChange={this.onFieldChange}
          user={this.state.user}
          onSubmit={this.onSubmit}
          // onRepresentativeChange={this.onRepresentativeChange}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[ADMIN_CREATE_USER_SPONSOR_SAGA],
    errorsFrontend: state.errors[`${ADMIN_CREATE_USER_SPONSOR_SAGA}_FRONTEND`],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createUserSponsor: (user) => dispatch(adminCreateUserSponsorSaga(user)),
    cleanErrors: () => dispatch(cleanErrors(ADMIN_CREATE_USER_SPONSOR_SAGA)),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUserSponsor);



// WEBPACK FOOTER //
// ./src/containers/Admin/UserSponsors/NewUserSponsor.jsx